const halls = {
    SelectRoom: {
        en: 'Select Room',
        cn: '选择房间',
    },
    enteredRoom: {
        en: 'Now you entered：{room}',
        cn: '您来到了：{room}',
    },
    hall01: {
        en: 'Novic',
        cn: '体验厅'
    },
    hall02: {
        en: 'Leisur',
        cn: '娱乐厅'
    },
    hall03: {
        en: 'Royal',
        cn: '旗舰厅'
    },
    hallLabel01: {
        en: 'Beginner',
        cn: '新手推荐'
    },
    hallLabel02: {
        en: 'Hot',
        cn: '热门'
    },
    hallLabel03: {
        en: 'VIP',
        cn: 'VIP'
    },
}

const trendChart = {
    trendChart: {
        en: 'Trend Chart',
        cn: '走势图'
    },
    zhuang: {
        en: 'B',
        cn: '庄'
    },
    tian: {
        en: 'Sky',
        cn: '天'
    },
    di: {
        en: 'Earth',
        cn: '地'
    },
    xuan: {
        en: 'Black',
        cn: '玄'
    },
    huang: {
        en: 'Yellow',
        cn: '黄'
    },
    errorMessage: {
        en: 'Failed to retrieve game data.',
        cn: '获取游戏记录失败'
    }
}

const history = {
    record:{
        en:'Record',
        cn:'记录'
    },
    rank:{
        en:'Rank',
        cn:'级'
    },
    noHistoryData:{
        en:'Oops! no data',
        cn:'哎呀！没有数据'
    },
    viewRecords:{
        en:'View up to 20 records within 7 days',
        cn:'最多查看7日内20条记录'
    },
    loadingMessage:{
        en:'loading...',
        cn:'加载中...'
    },
    time:{
        en:'Time',
        cn:'时间'
    },
    room:{
        en:'Room',
        cn:'房间'
    },
    bet:{
        en:'Bet',
        cn:'押注'
    },
    winOrLoss:{
        en:'Win/Loss',
        cn:'输赢'
    },
    win:{
        en:'Win',
        cn:'赢'
    },
    lose:{
        en:'Lose',
        cn:'输'
    },
    tianResult:{
        en:'heaven',
        cn:'天'
    },
    diResult:{
        en:'earth',
        cn:'地'
    },
    xuanResult:{
        en:'mystery',
        cn:'玄'
    },
    huangResult:{
        en:'yellow',
        cn:'黄'
    },
    hall:{
        en:'Hall',
        cn:'大厅'
    },
    // Niu Niu card types
    niuType0: {
        en: 'No Bull',
        cn: '无牛'
    },
    niuType1: {
        en: 'Bull 1',
        cn: '牛一'
    },
    niuType2: {
        en: 'Bull 2',
        cn: '牛二'
    },
    niuType3: {
        en: 'Bull 3',
        cn: '牛三'
    },
    niuType4: {
        en: 'Bull 4',
        cn: '牛四'
    },
    niuType5: {
        en: 'Bull 5',
        cn: '牛五'
    },
    niuType6: {
        en: 'Bull 6',
        cn: '牛六'
    },
    niuType7: {
        en: 'Bull 7',
        cn: '牛七'
    },
    niuType8: {
        en: 'Bull 8',
        cn: '牛八'
    },
    niuType9: {
        en: 'Bull 9',
        cn: '牛九'
    },
    niuType10: {
        en: 'Bull Bull',
        cn: '牛牛'
    },
    niuType11: {
        en: 'Five Picture',
        cn: '五花牛'
    },
    niuType12: {
        en: 'Four of a Kind',
        cn: '四炸'
    },
    niuType13: {
        en: 'Five Small Cards',
        cn: '五小牛'
    },
    unknownType: {
        en: 'Unknown',
        cn: '未知'
    },
}

const rules = {
    // Card Type Introduction section
    cardTypeIntroTitle: {
        en: '1. Card Type Introduction',
        cn: '1.牌型介绍'
    },
    
    // Table headers
    cardTypeTitle: {
        en: 'Card Type',
        cn: '牌型'
    },
    oddsTitle: {
        en: 'Odds',
        cn: '赔率'
    },
    explanationTitle: {
        en: 'Explanation',
        cn: '说明'
    },
    exampleTitle: {
        en: 'Example',
        cn: '示例'
    },
    
    // Card Types
    noNiu: {
        en: 'No Bull',
        cn: '无牛'
    },
    noNiuExplanation: {
        en: 'When any three cards in the five cards cannot add up to a multiple of 10, it is No Niu',
        cn: '五张牌中任意三张牌面相加不为10的整数倍即为无牛'
    },
    niuOne: {
        en: 'Bull One',
        cn: '牛一'
    },
    niuOneExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 1',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为1'
    },
    niuTwo: {
        en: 'Bull Two',
        cn: '牛二'
    },
    niuTwoExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 2',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为2'
    },
    niuThree: {
        en: 'Bull Three',
        cn: '牛三'
    },
    niuThreeExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 3',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为3'
    },
    niuFour: {
        en: 'Bull Four',
        cn: '牛四'
    },
    niuFourExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 4',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为4'
    },
    niuFive: {
        en: 'Bull Five',
        cn: '牛五'
    },
    niuFiveExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 5',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为5'
    },
    niuSix: {
        en: 'Bull Six',
        cn: '牛六'
    },
    niuSixExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 6',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为6'
    },
    niuSeven: {
        en: 'Bull Seven',
        cn: '牛七'
    },
    niuSevenExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 7',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为7'
    },
    niuEight: {
        en: 'Bull Eight',
        cn: '牛八'
    },
    niuEightExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 8',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为8'
    },
    niuNine: {
        en: 'Bull Nine',
        cn: '牛九'
    },
    niuNineExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a ones digit of 9',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加个位数为9'
    },
    niuNiu: {
        en: 'Bull Bull',
        cn: '牛牛'
    },
    niuNiuExplanation: {
        en: 'When any three cards in the five cards add up to a multiple of 10, and the other two cards add up to a multiple of 10',
        cn: '五张牌中任意三张牌相加为10的整数，另外两张牌相加为10的倍数'
    },
    fiveFlower: {
        en: 'Five Picture',
        cn: '五花牛'
    },
    fiveFlowerExplanation: {
        en: 'Any combination of J, Q, K',
        cn: '牌面为 J，Q，K的任意组合'
    },
    fourBomb: {
        en: 'Four of a Kind',
        cn: '四炸'
    },
    fourBombExplanation: {
        en: 'Four identical cards, with any fifth card',
        cn: '牌面有四张牌相同，第五张牌随意'
    },
    fiveSmall: {
        en: 'Five Small Cards',
        cn: '五小牛'
    },
    fiveSmallExplanation: {
        en: 'All five cards have points less than 5, and the sum of points is less than 10',
        cn: '五张牌的点数全部<5,且点数之和<10'
    },
    
    // Odds formats
    hallOdds3x1: {
        en: '3x Room: ',
        cn: '3倍(厅):'
    },
    hallOdds5x1: {
        en: '5x Room: ',
        cn: '5倍(厅):'
    },
    hallOddsNx1: {
        en: '10x Room: ',
        cn: '10倍(厅):'
    },
    
    // Other rule sections
    basicRulesTitle: {
        en: '2. Basic Rules',
        cn: '2.基础规则'
    },
    basicRules1: {
        en: 'The game uses one deck of cards, totaling 52 cards. The banker plays against four players, and each side is randomly dealt 5 cards.',
        cn: '游戏用牌为一副牌，共计52张。庄家一方闲家四方，每方随机发5张牌。'
    },
    basicRules2: {
        en: 'After the game starts, the banker is determined, and players can choose areas to place bets.',
        cn: '游戏开始后，庄家确定，闲家可以对下注区域进行选择下注。'
    },
    
    comparisonRulesTitle: {
        en: '3. Comparison Rules',
        cn: '3.比牌规则'
    },
    comparisonRules1: {
        en: 'All comparisons are made between the banker and players; players do not compare with each other.',
        cn: '所有的大小比较过程均是庄家和闲家比较，闲家和闲家之间不进行比较。'
    },
    comparisonRules2: {
        en: 'Hand rankings (from highest to lowest): Five Small Niu > Four Bomb > Five Flower Niu > Niu Niu > Niu 9 > Niu 8 > Niu 7 > Niu 6 > Niu 5 > Niu 4 > Niu 3 > Niu 2 > Niu 1 > No Niu.',
        cn: '牌型（从大到小）：五小牛>四炸>五花牛>牛牛>牛九>牛八>牛七>牛六>牛五>牛四>牛三>牛二>牛一>无牛。'
    },
    comparisonRules3: {
        en: 'When hands are tied, compare the card values: K > Q > J > 10 > 9 > 8 > 7 > 6 > 5 > 4 > 3 > 2 > A.',
        cn: '牌型相同比较牌数字大小：K>Q>J>10>9>8>7>6>5>4>3>2>A。'
    },
    comparisonRules4: {
        en: 'When card values are tied, compare suits: Spades > Hearts > Clubs > Diamonds. When two players have the same hand type, the highest card from the five cards is compared; if the highest cards are the same, the suits are compared.',
        cn: '数字相同比较花色：黑桃>红桃>梅花>方片。两个玩家相同牌型时，挑出五张牌按数字大小最大的一张牌做比较，若两方最大牌一样，则比较花色大小。'
    },
    
    specialHandsTitle: {
        en: '4. Special Hands',
        cn: '4.特殊牌型'
    },
    specialHands1: {
        en: 'Four Bomb: When 4 of the 5 cards have the same value, it is considered a Four Bomb hand and does not need to form a Niu.',
        cn: '四炸：即5张牌中有4张一样的牌，此时无需有牛。'
    },
    specialHands2: {
        en: 'Five Flower Niu: The "flower" refers to J, Q, K, and Five Flower Niu means all 5 cards are J, Q, or K, forming a special Niu Niu hand type. If both banker and player have Five Flower Niu hands, the highest card is compared; if they are equal, suits are compared.',
        cn: '五花牛：花指的是JQK，五花牛指的是5张牌全为JQK的特殊牛牛牌型。若庄家闲家都是五花牛牌型，则比较最大一张牌的大小，如果一样大，则比较花色。'
    },
    specialHands3: {
        en: 'Five Small Niu: All 5 cards have values less than 5, and the sum of all values does not exceed 10. If both banker and player have Five Small Niu hands, the highest card is compared; if they are equal, suits are compared. If 4 cards meet both the Four Bomb and Five Small Niu criteria, they are ranked as Five Small Niu.',
        cn: '五小牛：即5张牌的点数均小于5，且点数之和不超过10。若庄家闲家都是五小牛牌型，比较最大一张牌的大小，如果一样大，则比较花色。若4张牌即符合四炸又符合五小牛，则按五小牛的牌型计算。'
    },
    
    settlementRulesTitle: {
        en: '5. Settlement Rules',
        cn: '5.结算规则'
    },
    settlementRules: {
        en: 'Winning amount = Player\'s bet in winning area × hand type odds - commission. Player payout = Player\'s bet amount × banker\'s multiplier.',
        cn: '胜利获得金币=玩家下注获胜区域金币*牌型赔率—抽水。闲家赔付金额=玩家押注金额*庄家倍数。'
    },
    
    commissionRulesTitle: {
        en: '6. Commission Rules',
        cn: '6.抽水规则'
    },
    commissionRules1: {
        en: '5% of the profit from the winning area is taken as commission.',
        cn: '抽取开奖区域盈利的5%。'
    },
    commissionRules2: {
        en: 'Example 1: Bet 1000 on area A, area A wins, odds are 1, actual profit is 1000 × 1 × (1-5%) = 950',
        cn: '例子1：押注A区域1000元，开奖A区域，赔率为1，实际收益为1000*1*（1-5%）=950元'
    },
    commissionRules3: {
        en: 'Example 2: Bet 1000 each on areas A and B, areas B and C win, odds are 1, actual profit is 1000 [area B bet] × 1 × (1-5%) - 1000 [area A bet] = -50',
        cn: '例子2：分别押注A区域及B区域1000元，开奖B和C区域，赔率为1，实际收益1000【B区域押注额】×1× （1-5%）-1000【A区域押注额】=-50元'
    }
} 

// 一些弹出的提示信息 
const oToast = {
    lowBalance: {
        en: 'Insufficient balance, unable to enter this hall',
        cn: '余额不足，无法进入此厅',
    },
     hallDisabled: {
        en: 'Hall disabled',
        cn: '大厅已禁用',
    },
    notBetTime:{
        en:"Don't worry! It's not the bet time now",
        cn:'别急现在还不到下注时间'
    },
    cancelBetTips:{
        en:"You have successfully canceled, only one cancellation per round.",
        cn:'您已成功撤销，每局只能撤销一次'
    },
    cancel:{
        en:'Cancel',
        cn:'撤销'
    },
    startBet:{
        en:'START',
        cn:'开始下注'
    },
    stopBet:{
        en:'STOP',
        cn:'停止下注'
    },
    takeAll:{
        en:'TAKE ALL',
        cn:'通吃'
    },
    loseAll:{
        en:'LOSE ALL',
        cn:'通赔'
    },
    insufficientBalance:{
        en:'Insufficient balance',
        cn:'余额不足，无法下注'
    },
    maxBet:{
        en:'Sorry, single bet cannot exceed {maxLimit}.',
        cn:'抱歉，单注不能超过 {maxLimit}。'
    },
    noticeTitle:{
        en:'Notice!',
        cn:'注意!'
    },
    rechargePrompt:{
        en:'Recharge now and be the first to win big prizes!',
        cn:'立即充值，抢先一步赢大奖！'
    },
    continuePlaying:{
        en:'Continue Playing',
        cn:'继续游戏'
    },
    confirmExit:{
        en:'Confirm to leave',
        cn:'确认离开'
    },
    EnterGameFailed:{
        en:'Enter game failed, please try again!',
        cn:'进入游戏失败，请重新选择！'
    },
    stopBetting:{
        en:'Stop betting!',
        cn:'停止下注！'
    },
    notBettingPhase:{
        en:'Not in betting phase, cannot re-deal',
        cn:'当前不是下注阶段，无法续发'
    },
    noLastRoundBets:{
        en:'No last round bet records',
        cn:'没有上一轮下注记录'
    },
    insufficientBalanceForRedeal:{
        en:'Insufficient balance, need {amount} coins',
        cn:'余额不足，需要 {amount} 金币'
    }
};
export const oNiuniuGame = {
    ...halls,
    ...trendChart,
    ...history,
    ...rules,
    ...oToast,
    'niuniu': {
        en: 'Niu niu',
        cn: '牛牛',
    },
    'access': {
        en: 'Access',
        cn: '准入'
    },
    'limit': {
        en: 'Limit',
        cn: '限红'
    },
    'tips1': {
        en: 'Your amount is lower than',
        cn: '您的金额低于'
    },
    'tips2': {
        en: 'and cannot enter the room',
        cn: '，无法进入房间'
    },
    'quickJoin': {
        en: 'Quick Join',
        cn: '快速开始'
    },
    'playList': {
        en: 'Player List',
        cn: '玩家列表'
    },
    'user': {
        en: 'USER',
        cn: '玩家'
    },
    'amount': {
        en: 'AMOUNT',
        cn: '用户余额'
    },
    'trend': {
        en: 'Trend',
        cn: '走势'
    },
    'history': {
        en: 'History',
        cn: '历史'
    },
    'sec': {
        en: 'sec',
        cn: '秒'
    },
    'awarding':{
        en:'Awarding',
        cn:'派奖中'
    },
    'change': {
        en: 'Change',
        cn: '换房'
    },
    'dealer': {
        en: 'Dealer',
        cn: '庄'
    },
    'ReDeal': {
        en: 'Re-deal',
        cn: '续发'
    },
    'ReDealing': {
        en: 'Re-dealing',
        cn: '续发中'
    },
    'cancelBet': {
        en: 'Cancel',
        cn: '撤销'
    },
    'cancelBetTips': {
        en: 'Successfully cancelled. You can only cancel once per round.',
        cn: '您已成功撤销，每局只能撤销一次'
    },
    'cancelFailed': {
        en: 'Cancel failed',
        cn: '撤销失败'
    },
    'nextTips': {
        en: "Don't rush. It's not betting time yet.",
        cn: '别急现在还不到下注时间'
    },
    'start': {
        en: 'START',
        cn: '开始下注'
    },
    'stop': {
        en: 'STOP',
        cn: '停止下注'
    },
    'banker':{
        en:'banker',
        cn:'庄'
    },
    'hallType':{
        en:'Hall',
        cn:'厅别'
    },
    'betAmount':{
        en:'Bet Amount',
        cn:'下注金額'
    },
    'payout':{
        en:'Payout',
        cn:'输赢金额'
    },
    'chipValue':{
        en:'Chip value',
        cn:'筹码值'
    },
    'bettingArea':{
        en:'Betting Area',
        cn:'投注区域'
    }
};